<template>
  <div
    :id="containerId"
    ref="root"
    class="featured-select"
    @click.stop
  >
    <div
      class="featured-select__display input"
      :[tabindexAttr]="tabindex"
      @click="open"
    >
      <span
        v-if="selectedOption.name"
        class="featured-select__text"
      >
        {{ selectedOption.name }}
      </span>
      <input
        v-else
        :placeholder="placeholder"
        disabled
        class="featured-select__text"
      >

      <div
        v-if="selectedOption.featured"
        class="featured-select__badge"
      >
        <ChartArrowIcon class="featured-select__icon" />
        <span>{{ selectedOption.message }}</span>
      </div>

      <span class="icon has-text-link">
        <i class="fas fa-chevron-down" />
      </span>
    </div>

    <div
      v-if="isFocused"
      class="featured-select__list"
    >
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        :title="option.name"
        class="button is-ghost"
        @click.prevent="selectOption(option)"
      >
        <span>{{ option.name }}</span>
        <div
          v-if="option.featured"
          class="featured-select__badge ml-2"
        >
          <ChartArrowIcon class="featured-select__icon" />
          <span>{{ option.message }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import ChartArrowIcon from '@/assets/icons/ChartArrow.vue';
import { clickOutsideMixin } from './clickOutsideMixin';
import { findOptionByValue, nextSelectId } from './helpers';

export default {
  name: 'FeaturedSelect',
  components: { ChartArrowIcon },
  mixins: [clickOutsideMixin],
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, required: true },
    placeholder: { type: String, default: '' },
    tabindex: { type: [Number, String], default: null },
  },
  data() {
    return { containerId: nextSelectId() };
  },
  computed: {
    selectedOption() {
      return findOptionByValue(this.options, this.value) ?? {};
    },
    tabindexAttr() {
      return this.tabindex != null ? 'tabindex' : null;
    },
  },
  methods: {
    open() {
      if (this.isFocused) return;
      this.isFocused = true;
      this.$emit('focus');
    },
    selectOption(option) {
      this.$emit('input', option.value);
      this.$emit('change', option.value);
      this.isFocused = false;
      this.$emit('blur');
    },
  },
};
</script>

<style lang="scss" scoped>
.featured-select {
  position: relative;

  &__display {
    position: relative;
    display: flex;
    column-gap: .5rem;
    align-items: center;
    cursor: pointer;
    border: #D1D5DB solid 1px;
    border-radius: 6px;
    min-height: 42px;
    padding: 0 0.75rem;
    background-color: #fff;
  }

  &__text {
    flex: 1;
    appearance: none;
    border: none;
    pointer-events: none;
    background-color: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;

    &::placeholder {
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 26px;
      color: #3636364d;
    }
  }

  &__badge {
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 2px 12px;
    background-color: #EDE9FE;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #5B21B6;
    white-space: nowrap;
    pointer-events: none;
  }

  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 0.25rem;
  }

  &__list {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    z-index: 10;
    width: 100%;
    background-color: #fff;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(#000, 0.05);
    overflow: auto;
    max-height: 300px;

    .button {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: flex-start;
      padding: 10px;
      background-color: #fff;
      border: none;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
        text-align: left;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }

  .icon {
    pointer-events: none;
    flex-shrink: 0;
  }
}
</style>
